var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("full-list", {
    attrs: {
      sendOptions: _vm.sendOptions,
      options: _vm.options,
      optionsAll: _vm.optionsAll,
      optionsSelected: [_vm.optionSelected]
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ae643cb", { render: render, staticRenderFns: staticRenderFns })
  }
}